<template>
<div class="columns is-gap is-multiline">
  <div v-for="(faceNumerique, index) in liste"
    :key="index"
    class="column is-half-tablet is-one-third-desktop">
    <div :class="{'selectt': faceNumerique.select}">
      <div class="container_img_info">
      <img :src="faceNumerique.urlPhoto" class="imageBg" alt="">
      <div class="dot_select" @click="contolSelect(index)"
          :class="{'dot_select1': faceNumerique.select}">
          <div class="dot_selected" v-if="faceNumerique.select"></div>
      </div>
      <div class="level is-mobile bgBlur" @click="afficheFace(index)">
        <div class="level-left has-text-white">
          <div class="media margin_media"
               v-if="faceNumerique.extensionOpportunite.typeTarification &&
                  faceNumerique.extensionOpportunite.quantite">
            <b-icon
              icon="timer"
              class="media-left">
            </b-icon>
            <div class="media-content is-size-7">
              <label>Durée :</label><br>
              <label class="has-text-weight-bold">
                {{faceNumerique.laDuree}}
              </label>
            </div>
          </div>
        </div>
        <div
          class="level-right"
          v-if="faceNumerique.extensionOpportunite.tarifHt">
          <h3
            class="has-text-weight-bold has-text-white goToLeft">
            {{tarifHt(
              faceNumerique.extensionOpportunite.tarifHt*
              faceNumerique.extensionOpportunite.quantite)}}
          </h3>
        </div>
      </div>
    </div>
    <div class="infoBorder has-background-white" @click="afficheFace(index)">
      <div class="leftViolet topViolet rightViolet bottomVert">
        <label class="has-text-default">Adresse </label>
        <p class="has-text-dark has-text-weight-bold p_size12">
          {{adresse(faceNumerique)}}
        </p>
      </div>
      <div class="column leftViolet rightViolet">
        <div class="columns is-mobile is-multiline color-icon">
          <div
            class="column bottomVert is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="vector-intersection"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Format
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{faceNumerique.format}}
                </p>
              </div>
            </div>
          </div>
          <div
            class="column bottomVert is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="package-variant-closed"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Matériel
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{faceNumerique.materiel}}
                </p>
              </div>
            </div>
          </div>
          <div v-if="faceNumerique.extensionOpportunite.typeTarification &&
                faceNumerique.extensionOpportunite.quantite"
            class="column bottomVert is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="cellphone-screenshot"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Mode de diffusion
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{modeDiff(faceNumerique.extensionOpportunite.typeTarification)}}
                </p>
              </div>
            </div>
          </div>
          <div
            class="column bottomVert is-paddingless is-6">
            <div
              v-if="faceNumerique.extensionOpportunite.nbDiffusion"
              class="media">
              <b-icon
                icon="counter"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Diffusion/jour
                </label>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{faceNumerique.extensionOpportunite.nbDiffusion}}
                </p>
              </div>
            </div>
          </div>
            <div class="column bottomVert is-paddingless is-12"
              v-if="faceNumerique.extensionOpportunite.commentaire">
              <div class="media">
                <div class="media-content">
                    <label class="has-text-weight-bold has-text-link p_size14">
                      Commentaire : </label><br>
                    <p class="p_size12 has-text-default has-text-link">
                      {{faceNumerique.extensionOpportunite.commentaire}}
                    </p>
                </div>
              </div>
            </div>
        </div>
      </div>
      <a>
        <p class="p_size14 has-text-centered has-text-white color-plus-info">Plus d'informations</p>
       </a>
    </div>
    </div>
  </div>
  <app-detail-opportunites :detailFaceNumerique="detailFaceNumerique" v-if="show"/>
</div>
</template>

<script>
import { mapActions } from 'vuex';
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';
import { formatNum, formatAdresse, formatDureeNum, modeDiff } from '@/services/opportunite/formatTab';
import detailOpportunites from './detailOpportunites';

export default {
  name: 'listeFacesNumerique',
  props: ['detailPanneauxNumerique'],
  components: {
    appDetailOpportunites: detailOpportunites,
  },
  data() {
    return {
      show: false,
      detailFaceNumerique: {},
      bg: false,
    };
  },
  computed: {
    liste() {
      return this.detailPanneauxNumerique.map(el => ({
        ...el,
        laDuree: formatDureeNum(el.extensionOpportunite.typeTarification,
          el.extensionOpportunite.quantite),
      }));
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect(i) {
      this.detailPanneauxNumerique[i].select = !this.detailPanneauxNumerique[i].select;
      if (this.detailPanneauxNumerique[i].select) {
        this.detailPanneauxNumerique[i].icon = iconColorGetter('#49db70', TAILLE_ICON_GRAND);
        this.add(this.detailPanneauxNumerique[i].extensionOpportunite.tarifHt);
        this.addNbSelect();
      } else {
        this.detailPanneauxNumerique[i].icon = iconColorGetter('#009ce0', TAILLE_ICON_GRAND);
        this.substract(this.detailPanneauxNumerique[i].extensionOpportunite.tarifHt);
        this.substractNbSelect();
      }
    },
    afficheFace(i) {
      this.detailFaceNumerique = this.detailPanneauxNumerique[i];
      this.show = true;
    },
    tarifHt(t) {
      return formatNum(t);
    },
    adresse(data) {
      return formatAdresse(data);
    },
    modeDiff(t) {
      return modeDiff(t);
    },
    formatDureeNum(t, q) {
      return formatDureeNum(t, q);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/panneauxNumeriques/listesFacesNumerique.vue